<aside class="fixed top-0 left-0 h-screen w-80 border-r border-gray-200 bg-lightBlue flex flex-col">
  <div class="px-4 py-4 border-b border-gray-200 flex flex-col items-center">
    <img src="/assets/images/lohi_dark.svg" alt="LOHI Logo" class="h-8 w-auto" />
    <span class="text-base font-semibold text-center">{{ carrierName$ | async }}</span>
  </div>

  <nav class="px-2 flex-grow mt-4">
    <ng-container *ngFor="let item of sidebarItems; trackBy: trackByLink">
      <a
        class="flex items-center font-inter text-base font-bold rounded-md cursor-pointer p-1 mt-1 transition-all"
        [ngClass]="{
          'bg-darkBlue text-white': isActive(item.link),
          'text-black hover:bg-gray-100': !isActive(item.link)
        }"
        (click)="toggleSubmenu(item.label, item.link)"
      >
        <img
          [src]="item.icon"
          [alt]="item.label"
          class="h-3 w-3 mr-3 text-black"
          [ngClass]="{ 'fill-white': isActive(item.link) }"
        />
        {{ item.label }}

        <span *ngIf="item.children?.length > 0" class="ml-auto">
          <img
            src="/assets/icons/new-dashboard/down_arrow.svg"
            alt="Expand"
            class="h-3 w-3 transition-transform duration-200 transform"
            [ngClass]="{
              'rotate-180': expandedSubmenus[item.label],
              'filter brightness-0 invert': expandedSubmenus[item.label] !== false
            }"
          />
        </span>
      </a>

      <div *ngIf="item.children?.length > 0 && expandedSubmenus[item.label]" class="ml-2 mt-2">
        <a
          *ngFor="let subItem of item.children; trackBy: trackByLink"
          class="flex items-center font-inter text-sm font-medium rounded-md cursor-pointer p-1 mt-1 transition-all"
          [ngClass]="{
            'bg-gray-100 text-black': isChildActive(subItem.link),
            'text-gray-600 hover:bg-gray-200': !isChildActive(subItem.link)
          }"
          (click)="setActiveLink(subItem.link, item.label)"
        >
          <img [src]="subItem.icon" [alt]="subItem.label" class="h-3 w-3 mr-2" />
          {{ subItem.label }}
        </a>
      </div>
    </ng-container>
  </nav>

  <div class="mt-auto px-2 mb-2">
    <lohi-company-switcher *ngIf="isInternal$ | async" class="w-full"></lohi-company-switcher>
    <a
      class="flex w-full items-center text-left font-inter text-base font-bold rounded-md cursor-pointer p-1 mt-1 transition-all text-white bg-blue-500"
      href="/owner-dashboard"
    >
      Go back to V1
    </a>
    <a
      *ngFor="let item of bottomItems; trackBy: trackByLink"
      class="flex w-full items-center text-left font-inter text-base font-bold rounded-md cursor-pointer p-1 mt-1 transition-all"
      [ngClass]="{
        'bg-darkBlue text-white': activeLink === item.link,
        'text-black hover:bg-gray-100': activeLink !== item.link
      }"
      (click)="setActiveLink(item.link)"
    >
      <img
        [src]="item.icon"
        [alt]="item.label"
        class="h-3 w-3 mr-3"
        [ngClass]="{ 'fill-white': activeLink === item.link }"
      />
      {{ item.label }}
    </a>
    <a
      class="flex w-full items-center text-left font-inter text-base font-bold rounded-md cursor-pointer p-1 mt-1 transition-all"
      (click)="logout()"
    >
      <img src="/assets/icons/new-dashboard/sign_out_icon.svg" alt="logout" class="h-3 w-3 mr-3" />
      Sign Out
    </a>
  </div>
</aside>
